module.exports = __webpack_public_path__ + "static/media/img_minigame_fish_crosshair.938be8a2.svg";